import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { Raffle } from '../../influencer/models/raffle.model';
import { ApiRoutes } from '../../../shared/constants/api-routes.constants';

@Injectable({
  providedIn: 'root',
})
export class RaffleService {
  constructor(private http: HttpClient) {}

  getAllRaffles(): Observable<ApiResponse<Raffle[] | null>> {
    return this.http.get<ApiResponse<Raffle[] | null>>(
      ApiRoutes.RAFFLE.GET_ALL_RAFFLE
    );
  }

  getRafflesByInfluencer(
    username: string
  ): Observable<ApiResponse<Raffle[] | null>> {
    return this.http.get<ApiResponse<Raffle[] | null>>(
      ApiRoutes.RAFFLE.GET_RAFFLES_BY_INFLUENCER(username)
    );
  }
}
